import { render, staticRenderFns } from "./MdProductItem.vue?vue&type=template&id=3bf154e2&scoped=true&"
import script from "./MdProductItem.vue?vue&type=script&lang=js&"
export * from "./MdProductItem.vue?vue&type=script&lang=js&"
import style0 from "./MdProductItem.vue?vue&type=style&index=0&id=3bf154e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf154e2",
  null
  
)

export default component.exports